export const STORAGE_KEY = 'activeStakeholdersReports';
